import '@/fsd/shared/ui/static/css/confirmAllert.scss';
import '@/fsd/shared/ui/static/css/notification.scss';

import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ReactNotifications } from 'react-notifications-component';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import locale from 'antd/locale/ru_RU';


import App from './App';
import { queryClient } from '@/fsd/shared/lib/react-query/queryClient';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <ConfigProvider locale={locale}>
        <ReactNotifications />
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
